import { createAction } from 'typesafe-actions';

export const PDP_MEDIA_PREVIEW_CLICK = createAction('ui/PDP_MEDIA_PREVIEW_CLICK')<{
  mediaType: string;
  contentLink: string;
}>();
export const PDP_MEDIA_PREVIEW_HOVER = createAction('ui/PDP_MEDIA_PREVIEW_HOVER')<{
  mediaType: string;
  contentLink: string;
}>();
export const PDP_MEDIA_LOADED = createAction('ui/PDP_MEDIA_LOADED')<{
  mediaType: string;
  contentLink: string;
  loadTime?: number;
}>();
